export const LANGUAGE_STORAGE_KEY = "appgradeLng";
export const LANGUAGE = {
    en: "en",
    ru: "ru",
} as const;

export type SupportedLanguage = (typeof LANGUAGE)[keyof typeof LANGUAGE];

export const DEFAULT_LANGUAGE = LANGUAGE.en;
export const SUPPORTED_LANGUAGES = Object.values(LANGUAGE);

export const isSupportedLanguage = (language: string | null): language is SupportedLanguage =>
    SUPPORTED_LANGUAGES.includes(language as SupportedLanguage);

export const getInitialLanguage = (): SupportedLanguage => {
    if (typeof window === "undefined") {
        return DEFAULT_LANGUAGE;
    }

    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);

    return isSupportedLanguage(storedLanguage) ? storedLanguage : DEFAULT_LANGUAGE;
};

export const saveLanguage = (language: SupportedLanguage) => {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
};
